import { useState } from "react";
import useAxiosPrivate from "../../utils/CustomHooks/useAxiosPrivate/useAxiosPrivate";
import { USER_POST_ADD_GRANT_ROLES, USER_PUT_ADD_ORG } from "../../Api/axios";
import useAuth from "../../utils/CustomHooks/useAuth/useAuth";
import { Validation } from "../../utils/Validation/Validation";
import Select from "react-select";
import "./UserManipulation.css";

export function UserManipulation(props) {

  const {
    listAllUsers
  } = props;

  // const loginUserName = Validation();
  const [errorMessage, setErrorMessage] = useState("");
  const [isSaveSuccess, setSaveSuccess] = useState("");
  const [isRole, setIsRole] = useState();
  const [isOrg, setIsOrg] = useState();
  const [isUser, setIsUser] = useState();
  const axiosPrivate = useAxiosPrivate();
  const { dictionaryOrg, updateRequestUsers } = useAuth();
  const filterUsers = listAllUsers.filter(el => el?.roles[0] !== 'ADMIN')

  const optionsRoles = [
    { value: "FORWARDER", label: "FORWARDER" },
    { value: "CAPTAIN", label: "CAPTAIN" },
    { value: "CUSTOM", label: "CUSTOM" },
    { value: "ADMIN", label: "ADMIN" },
    { value: "USER", label: "USER" },
    { value: null, label: "Select role" },
  ];

  const optionOrg = [
    ...dictionaryOrg.map((el) => ({
      value: el?.id,
      label: el?.name,
    })),
    { value: null, label: "Select organization" },
  ];

  const optionUsers = [
    ...filterUsers.map((el) => ({
      value: el?.login,
      label: el?.login,
    })),
    { value: null, label: "Select user" },
  ];

  const onChangeRoles = (optionsRoles) => {
    optionsRoles.value ? setIsRole(optionsRoles) : setIsRole(null);
  };

  const onSelectOrg = (optionOrg) => {
    optionOrg.value ? setIsOrg(optionOrg) : setIsOrg(null);
  };

  const onSelectUser = (optionUser) => {
    optionUser.value ? setIsUser(optionUser) : setIsUser(null);
  };

  function saveProfile() {
    return (function assignRoles() {
      if (!isRole || !isUser) return new Promise((resolve) => resolve());
      return axiosPrivate.post(
        USER_POST_ADD_GRANT_ROLES,
        {
          login: isUser.value,
          roles: [isRole.value],
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
    })()
      .then(function assignOrg() {
        if (!isOrg || !isUser) return new Promise((resolve) => resolve());
        return axiosPrivate.put(USER_PUT_ADD_ORG, undefined, {
          params: {
            login: isUser.value,
            org_id: isOrg.value,
          },
        });
      })
      .then(() => {
        setSaveSuccess("Changes successfully saved!");
        setErrorMessage("");
        updateRequestUsers();
        setTimeout(() => {
          setSaveSuccess("");
        }, 5000);
      })
      .catch((error) => {
        if (error.response.data.includes('not found')) {
          setErrorMessage("User not found!");
        } else {
          setErrorMessage("Error saving changes, please try later!");
        }
        setSaveSuccess("");
        setTimeout(() => {
          setErrorMessage("");
        }, 5000);
      });
  }

  return (
    <div className="profile-user-manipulation">
      <h3 className="profile-user-title">User manipulation:</h3>
      <div className="profile-user-input__field">
        <label className="profile-user-input__label">Select the username</label>
        <Select
          defaultValue={{ value: null, label: "Select user" }}
          options={optionUsers}
          onChange={onSelectUser}
        />
      </div>
      <div className="profile-user-input__field">
        <label className="profile-user-input__label">Choose a role</label>
        <Select
          defaultValue={{ value: null, label: "Select role" }}
          options={optionsRoles}
          onChange={onChangeRoles}
        />
      </div>
      <div>
        <div className="profile-user-input__field">
          <label className="profile-user-input__label">
            Choose a organization
          </label>
          <Select
            defaultValue={{ value: null, label: "Select organization" }}
            options={optionOrg}
            onChange={onSelectOrg}
          />
        </div>
      </div>
      <div className="profile-user__buttons">
        <p className="profile-user__buttons-save-error">{isSaveSuccess}</p>
        <p className="profile-user__buttons-error-message">{errorMessage}</p>
        <button
          disabled={!isRole && !isOrg}
          onClick={saveProfile}
          className="profile-user__buttons-save"
        >
          Save
        </button>
      </div>
    </div>
  );
}
